export default __webpack_public_path__ + "static/featured_image_og_codilime_low_level_programming-c2f18752e3f887d048e6a092a7b01b74.jpg";